import React from 'react'

export const NothingSelected = () => {
  return (
    <div className='nothing__main-context'>
        <p>
            Select something
            <br/>
            por create an entry!
        </p>
        <i className='far fa-star fa-4x mt-5'></i>
        
    </div>
  )
}
